import React, {Component, PropTypes} from 'react';

import isTouchDevice from '../../../utils/isTouchDevice';

import zoomerStore from '../../../stores/zoomer';
import mapActions from '../../../actions/map';
import tooltipActions from '../../../actions/tooltip';

export default class SIMSvgSeat extends Component {

  onMouseEnter () {
    tooltipActions.emit(tooltipActions.EVENTS.HOVER_ENTER, {type: 'seat', el: this});
  }

  static onMouseLeave () {
    tooltipActions.emit(tooltipActions.EVENTS.HOVER_LEAVE);
  }

  selectSeat () {
    if (this.props.available && !zoomerStore.data.clickDisabled) {
      mapActions.emit(mapActions.EVENTS.SEAT_TOGGLE, this.props);
    }
  }

  render () {
    if (this.props.available === undefined) {
      return false;
    }

    var className = 'seat';
    className += this.props.available ? ' is-available' : '';
    className += this.props.activeSeats.indexOf(this.props.id) !== -1 ? ' is-active' : '';

    var attributes = {
      'data-component': 'svg__seat',
      id:               this.props.id,
      onClick:          this.selectSeat.bind(this),
      className:        className,
      cx:               this.props.position.x,
      cy:               this.props.position.y,
      r:                this.props.available ? this.props.size : this.props.size * 0.85 // TODO, validate this
    };

    if (!isTouchDevice) {
      attributes.onMouseEnter = this.onMouseEnter.bind(this);
      attributes.onMouseLeave = SIMSvgSeat.onMouseLeave;
    }

    this.props.attributes && this.props.attributes.forEach(function (attr) {
      attributes['data-' + attr] = '';
    });

    return <circle {...attributes} />;
  }
}

SIMSvgSeat.propTypes = {
  id:           PropTypes.string.isRequired,
  position:     PropTypes.object.isRequired,
  size:         PropTypes.number.isRequired,
  available:    PropTypes.bool,
  attributes:   PropTypes.arrayOf(PropTypes.string),
  activeSeats:  PropTypes.arrayOf(PropTypes.string).isRequired
};



// WEBPACK FOOTER //
// ./frontend/react/sim/core/components/map/svg/seat.jsx